// @ts-nocheck
import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../assets/Icons/lucideIcons/x.svg';
import PropTypes from 'prop-types';

import useModalDisclosure from '../../../../hooks/useModalDisclosure';
import CanvasEditor from '../FieldComponents/CanvasEditor';

const ViewCanvas = ({ value, attribute }) => {
  const { open: openPreview, handleOpen, handleClose } = useModalDisclosure();

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography
          component="span"
          onClick={handleOpen}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          View Canvas
        </Typography>
      </Box>

      <Dialog open={openPreview} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            View {attribute?.label}
          </Box>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ p: 2 }}>
          <CanvasEditor value={value} readOnly />
        </DialogContent>
      </Dialog>
    </>
  );
};

ViewCanvas.propTypes = {
  value: PropTypes.string,
  attribute: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

export default ViewCanvas;
